import React, { useState } from "react";
import { Link } from "react-router-dom";
import MainContent from "@components/content";
import Timeline from "@components/timeline";
import css from "../index.module.css";

const timelineData = [
  {
    status: "Проблема",
    date: "24 февраля 2026",
    title: "Блокировка доступа к Госуслугам",
    color: "danger",
    description:
      "Учетная запись в ЕСИА заблокирована на 72 часа. Система безальтернативно требует установить мессенджер «МАХ» для восстановления доступа.",
  },
  {
    status: "Прокуратура Российской Федерации",
    date: "24 февраля 2026",
    title: "Подача жалобы",
    color: "success",
    description:
      "Направлена жалоба на необоснованное ограничение доступа к госуслугам и нарушение антимонопольного законодательства.",
  },
  {
    status: "Генеральная прокуратура Российской Федерации",
    date: "26 февраля 2026",
    title: "Возбуждение надзорного производства",
    color: "success",
    description:
      "Генпрокуратура РФ приняла жалобу и направила материалы в Минцифры и ФАС России для проверки доводов о нарушении закона. Исполнение поручения поставлено на контроль Генпрокуратуры.",
  },
  {
    status: "Министерство цифрового развития Российской Федерации",
    date: "24 марта 2026",
    title: "Ответ № П13-254665",
    color: "danger",
    description:
      "Информационно-разъяснительное письмо Минцифры России о порядке ограничения и восстановления доступа к учётным записям ЕСИА. Обращение рассмотрено не по существу поставленных вопросов.",
  },
  {
    status: "Министерство цифрового развития Российской Федерации",
    date: "27 марта 2026",
    title: "Ответ № 343372425",
    color: "danger",
    description:
      "Обращение полностью проигнорировано по существу поставленных вопросов. Дана формальная отписка.",
  },
  {
    status: "Генеральная прокуратура Российской Федерации, Минцифры РФ",
    date: "25 марта 2026",
    title: "Жалоба",
    color: "danger",
    description:
      "Оспаривается политика безальтернативного использования мессенджера «МАХ» или личного визита в МФЦ для восстановления доступа к заблокированной учётной записи в ЕСИА, а также ненадлежащее рассмотрение обращения.",
  },
  {
    status: "Федеральная антимонопольная служба Российской Федерации",
    date: "24 апреля 2026",
    title: "Обращение рассмотрено",
    color: "success",
    description:
      "Обращение рассмотрено Заместителем Руководителя ФАС России по существу поставленных вопросов. См. материалы дела.",
  },
  // {
  //   status: "Подготовка",
  //   date: "2 апреля 2026",
  //   title: "Подготовка административного иска",
  //   color: "",
  //   description:
  //     "Генеральная прокуратура Российской Федерации отказала в возбуждении производства. Дело находится в стадии подготовки административного иска."
  // },
];

const initialCaseStatus = {
  label: "Дело закрыто",
  code: "satisfied",
  variant: "satisfied",
};

const LegalCase5Page = () => {
  const [caseStatus] = useState(initialCaseStatus);

  return (
    <MainContent>
      <div className={css.casePage}>
        <div className={css.caseHeader}>
          <div className={css.caseHeaderTop}>
            <Link to="/legal" className={css.backLink}>
              <span className={css.backIcon}>←</span>
              <span>Назад к делам</span>
            </Link>
            <div
              className={`${css.caseStatus} ${css[`caseStatus_${caseStatus.variant}`]
                }`}
            >
              <span className={css.caseStatusDot} />
              <span className={css.caseStatusText}>{caseStatus.label}</span>
            </div>
          </div>
          <h1>Блокировка ЕСИА и принуждение к установке мессенджера «МАХ»</h1>
          <span className={css.caseMeta}>
            Федеральное законодательство · 2026 г.
          </span>
        </div>

        <div className={css.caseLayout}>
          <div className={css.caseDescription}>
            <div className={css.caseSection}>
              <div className={css.caseSectionTitle}>Суть (фабула)</div>
              <p>
                Личный кабинет на портале «Госуслуги» был заблокирован на 72 часа под предлогом «подозрительной активности». Для досрочного восстановления доступа система безальтернативно навязывала регистрацию в стороннем коммерческом мессенджере «МАХ».
              </p>
            </div>

            <div className={css.caseSection}>
              <div className={css.caseSectionTitle}>Моя позиция</div>
              <p>
                Согласно ФЗ-210, органы власти не вправе требовать от заявителя действий, не предусмотренных законом. Наличие у меня УКЭП (усиленной квалифицированной электронной подписи) игнорировалось системой, хотя по ФЗ-63 она является абсолютным аналогом собственноручной подписи.
              </p>
              <p style={{ marginTop: 10 }}>
                Безальтернативное навязывание продукта конкретной коммерческой организации (ООО «МАХ») имеет явные признаки нарушения ст. 10 ФЗ «О защите конкуренции».
              </p>
            </div>

            <div className={css.caseSection}>
              <div className={css.caseSectionTitle}>Позиция ведомства</div>
              <p>
                Материалы дела были официально направлены в Министерство цифрового развития (Минцифры РФ) и Федеральную антимонопольную службу (ФАС России) для проведения проверки. Исполнение поручения поставлено на контроль Генпрокуратуры.
              </p>
            </div>

            <div className={css.caseSection}>
              <div className={css.caseSectionTitle} style={{ margin: 0 }}>Материалы</div>
              <div className={css.caseMaterialsList}>
                <a href="https://dash.leecyber.com/drive/shared/248d0dc9-3bc7-4c39-a0ce-c5ac64a55805" className={css.caseMaterialLink} target="_blank" rel="noreferrer">
                  Поручение Генпрокуратуры в ФАС и Минцифры
                </a>
                <a href="https://dash.leecyber.com/drive/shared/16e34d88-3f3b-4de8-871d-ad3ade890611" className={css.caseMaterialLink} target="_blank" rel="noreferrer">
                  Ответ Минцифры России за №П13-254665
                </a>
                <a href="https://dash.leecyber.com/drive/shared/c4d89084-7faf-4231-8369-4eac899dddcd" className={css.caseMaterialLink} target="_blank" rel="noreferrer">
                  Ответ Заместителя Руководителя ФАС России
                </a>
              </div>
            </div>
          </div>

          <div className={css.caseTimeline}>
            <div className={css.caseSectionTitle} style={{ marginBottom: 25 }}>Ход дела</div>
            <Timeline data={timelineData} />
          </div>
        </div>
      </div>

      <p className={css.caseDisclaimer}>
        Все представленные дела — результат моей самостоятельной практики. Опубликованные материалы не являются профессиональной юридической консультацией, носят исключительно ознакомительный характер и отражают мое субъективное мнение.
      </p>
    </MainContent>
  );
};

export default LegalCase5Page;